import { render, staticRenderFns } from "./_template-indicator-navigator-consolidated.vue?vue&type=template&id=2620fd8d&scoped=true&"
import script from "./_template-indicator-navigator-consolidated.vue?vue&type=script&lang=js&"
export * from "./_template-indicator-navigator-consolidated.vue?vue&type=script&lang=js&"
import style0 from "./_template-indicator-navigator-consolidated.vue?vue&type=style&index=0&id=2620fd8d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620fd8d",
  null
  
)

export default component.exports